import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  background: rgb(255 255 255 / 100%);
  width: 100vw;
  height: 100vh;
  z-index: 9999;
`;
